import * as z from "zod";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum VendorNameFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export const VendorNameFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.VENDOR_NAME,
  VendorNameFilterQuery,
  z.array(z.string()),
);

export type VendorNameFilter = z.infer<typeof VendorNameFilterSchema>;
